import { Divider } from "antd";
import React, { Component } from "react";
import "./app_dashboard_list.css";
import Config from "../../../Config";
import RouteBloc from "../../../bloc/route_bloc";
import QuotationBloc from "../../../bloc/quotation_bloc";
import ProposalBloc from "../../../bloc/mrtt_proposal_bloc";

class AppDashboardList extends Component {
    constructor(props) {
        super(props);
        let routeParams = RouteBloc.extractRouteParamsFromProps(this.props.props);
        this.state = {
            client: Config.context,
            route: routeParams,
        }
    }

    getStatusName() {
        let quotationStatus = ''
        if (this.props.status) {
            this.props.status === 'Proposal Proceeded' ? quotationStatus = 'GENERATED' :
                this.props.status === 'Quotation Created' ? quotationStatus = 'PENDING' :
                    this.props.status === 'Draft' ? quotationStatus = 'DRAFT' :
                        quotationStatus = this.props.status;
        }
        return quotationStatus;
    }

    getDisplayStatus() {
        if (this.props.status) {
            let status = Config[this.props.module ? this.props.module : 'proposal'].statusMapping[this.getStatusName()].display
            return ' • ' + status;
        } else {
            return ''
        }
    }

   async handleViewListDetails() {
        if (this.getStatusName() == 'DRAFT') {
            if (this.props.module == 'quotation') {
                let editable = await QuotationBloc.editGeneratedQuotation(this.props.id);
                editable.success ?
                    window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation_personal_details}/${this.props.id}` :
                    this.setState({ isOpen: true, title: 'Notification', message: 'This quotation cannot be edit or update. ' })
            } else {
                let editable = await ProposalBloc.editGeneratedProposal(this.props.id);
                editable.success ?
                    window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal_provide_details}/${this.props.id}` :
                    this.setState({ isOpen: true, title: 'Notification', message: 'This quotation cannot be edit or update. ' })
            }
        } else {
            this.props.module == 'quotation' ?
                window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation_details}/${this.props.id}` :
                window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal_details}/${this.props.id}`
        }
    }

    render() {
        return (
            <>
                <div className="clickable_container d-flex" onClick={() => this.handleViewListDetails()}>
                    <div className="mx-2 align-content-center" style={{ width: 40 }}>
                        <div
                            className="homescreen__pending_list_number d-flex justify-content-center align-items-center"
                            style={{
                                color: Config[this.props.module ? this.props.module : 'proposal'].statusMapping[this.getStatusName()].color,
                                backgroundColor: Config[this.props.module ? this.props.module : 'proposal'].statusMapping[this.getStatusName()].backgroundColor,
                                height: 40,
                                width: 40
                            }}
                        >
                            {this.props.index || 0}
                        </div>
                    </div>
                    <div className="align-items-center d-flex row m-0">
                        <div className="homescreen__pending_list_text">
                            {this.props.name || 'N/A'}
                        </div>
                        <div className="mt-1">
                            Ref No. {this.props.refNo || ' N/A '}
                            {' '} • ID No. {this.props.idNo || ' N/A '}
                            {' '} • Last Updated {this.props.lastUpdate || ' N/A '}
                            {' '}<b>{this.getDisplayStatus()}</b>
                            {this.props.module && this.props.module === 'quotation' ? ' | Quotation' : ' | Proposal'}
                        </div>
                    </div>
                </div>
                {this.props.lastIndex === false && <Divider />}

            </>
        );
    }
}

export default AppDashboardList;
